module.exports = __webpack_public_path__ + "static/media/loader.47b4a672.svg";